<template>
    <div class="container">
        <api-navbar :services="serviceList"
                    :searchedValue.sync="searchedValue"
                    :active="serviceToShow"
                    @navigate="serviceToShow = $event"/>
        <div class="row" v-if="filteredList.length === 0">
            <div class="col-12">
                <h3>No results</h3>
            </div>
        </div>
        <div class="row endpoint-row"
             v-for="(endpoint, key) in filteredList"
             v-else>
            <api-endpoint :endpoint="endpoint"
                          :key="endpoint.name"/>
        </div>

    </div>
</template>
<script>
import ApiEndpoint from './ApiEndpoint';
import ApiNavbar from './ApiNavbar';
/**
 * @module ApiBrowser
 * @description component used to display the api browser
 * */

export default {
    name: 'api-browser',
    components: {ApiNavbar, ApiEndpoint},
    data () {
        return {
            searchedValue: '',
            serviceToShow: ''
        };
    },
    props: {
        routes: {
            type: [Array, Object],
            required: true,
            default: () => []
        }
    },
    computed: {
        serviceList () {
            return this.routes.map(({name}) => name);
        },
        filteredList () {
            let result = this.routes;
            if(this.serviceToShow) {
                result = result.filter(route => route.name === this.serviceToShow);
            }
            if(this.searchedValue) {
                let search = this.searchedValue.trim();
                result = result.filter(route => {
                    let found = false;
                    for(let key in route.data) {
                        if(key.includes(search)) {
                            found = true;
                        }
                    }
                    return route.name.includes(search) || found;
                });
            }
            return result;
        }
    }
};
</script>

<style lang="scss">
    .endpoint-row {
        &:not(:last-child) {
            border-bottom: 2px solid;
            @include color('border-color', primary-active);
        }
    }
    .endpoint-route {
        &:not(:last-child) {
            border-bottom: 1px solid;
            @include color('border-color', primary);
        }
    }
</style>
